var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSVsmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7892 24C6.2909 24 1.64276 20.428 0.113724 15.5172C1.43889 14.6949 2.54701 13.5675 3.33338 12.2321C2.52482 10.8586 1.3744 9.70464 0 8.87829C1.39798 3.76429 6.14527 0 11.7899 0C18.5329 0 24 5.3729 24 11.9997C23.9993 18.6278 18.5329 24 11.7892 24ZM11.7171 7.48443C8.1403 7.48443 5.01912 9.39408 3.34793 12.2321C5.01843 15.0708 8.1403 16.9804 11.7171 16.9804C15.2931 16.9804 18.415 15.0708 20.0862 12.2321C18.4157 9.39408 15.2931 7.48443 11.7171 7.48443Z",
    fill: "#F32B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSVsmall);
export default __webpack_public_path__ + "static/media/logoSVsmall.9ed96bd74103eac24700ae55a3c2fe41.svg";
export { ForwardRef as ReactComponent };